/* TEC Choose-Your-Location guard v6
 * Persists location selection as cart attribute. Syncs across cart drawer re-renders.
 * Checkout click interception moved to tec-cart-address-prefill.js v2.
 */
(function () {
  if (window.__tecLocationGuardLoaded) return;
  window.__tecLocationGuardLoaded = true;
  window.__tecLocationGuardVersion = 6;

  var SELECT_SELECTOR = 'select[name="attributes[Choose Your Location]"]';
  var HIDDEN_NAME = 'attributes[Choose Your Location]';
  var HIDDEN_MARKER_ATTR = 'data-tec-location-mirror';

  function log() {
    try { console.log.apply(console, ['[TEC]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function getSelects() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECT_SELECTOR));
  }
  function currentValue() {
    var selects = getSelects();
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].value) return selects[i].value;
    }
    return '';
  }

  function syncHiddenMirrors() {
    var value = currentValue();
    var forms = document.querySelectorAll('form[action="/cart"], form[action^="/cart/"], form[action^="/cart?"]');
    forms.forEach(function (form) {
      var existing = form.querySelector('input[' + HIDDEN_MARKER_ATTR + ']');
      if (!existing) {
        existing = document.createElement('input');
        existing.type = 'hidden';
        existing.name = HIDDEN_NAME;
        existing.setAttribute(HIDDEN_MARKER_ATTR, '1');
        form.appendChild(existing);
      }
      existing.value = value;
    });
  }

  function persist(value) {
    if (!value) return Promise.resolve();
    var body = 'attributes%5BChoose%20Your%20Location%5D=' + encodeURIComponent(value);
    log('persist ->', value);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body,
      credentials: 'same-origin',
      keepalive: true
    }).then(function (r) {
      log('persist response status', r.status);
      return r;
    }).catch(function (err) {
      log('persist FAILED', err && err.message);
    });
  }

  function syncSiblings(source) {
    var v = source.value;
    getSelects().forEach(function (sel) {
      if (sel !== source && sel.value !== v) sel.value = v;
    });
  }

  ['change', 'input', 'blur'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches(SELECT_SELECTOR)) return;
      var value = t.value || '';
      log('event', evt, 'value', value);
      syncSiblings(t);
      syncHiddenMirrors();
      if (value) persist(value);
    }, true);
  });

  function initSync() {
    syncHiddenMirrors();
    var v = currentValue();
    if (v) {
      log('init: pre-existing value', v, '— persisting');
      persist(v);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSync);
  } else {
    initSync();
  }

  // MutationObserver: detect cart drawer re-renders
  try {
    var mo = new MutationObserver(function (records) {
      var sawSelect = false;
      for (var i = 0; i < records.length && !sawSelect; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(SELECT_SELECTOR)) || (n.querySelector && n.querySelector(SELECT_SELECTOR))) {
            sawSelect = true; break;
          }
        }
      }
      if (sawSelect) {
        log('cart re-render detected with location field');
        syncHiddenMirrors();
        var v = currentValue();
        if (v) persist(v);
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  // FETCH hook — inject attribute into cart-related POSTs
  try {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var isCart = /\/cart(\/(update|add|change|clear)(\.js)?)?(\?|$)/i.test(url);
        if (isCart && init && init.method && /post/i.test(init.method)) {
          var v = currentValue();
          if (v && init.body) {
            if (typeof init.body === 'string') {
              try {
                var parsed = JSON.parse(init.body);
                parsed.attributes = parsed.attributes || {};
                if (!parsed.attributes['Choose Your Location']) {
                  parsed.attributes['Choose Your Location'] = v;
                  init.body = JSON.stringify(parsed);
                  log('fetch hook: injected JSON for', url);
                }
              } catch (e) {
                if (init.body.indexOf('Choose%20Your%20Location') === -1 &&
                    init.body.indexOf('Choose+Your+Location') === -1) {
                  init.body += (init.body.length ? '&' : '') + 'attributes%5BChoose%20Your%20Location%5D=' + encodeURIComponent(v);
                  log('fetch hook: appended form body for', url);
                }
              }
            } else if (init.body instanceof FormData) {
              if (!init.body.has('attributes[Choose Your Location]')) {
                init.body.append('attributes[Choose Your Location]', v);
                log('fetch hook: appended FormData for', url);
              }
            }
          }
        }
      } catch (err) {}
      return originalFetch(input, init);
    };
  } catch (e) {}

  // XHR hook
  try {
    var XHR = window.XMLHttpRequest.prototype;
    var origOpen = XHR.open;
    var origSend = XHR.send;
    XHR.open = function (method, url) {
      this.__tecUrl = url;
      this.__tecMethod = method;
      return origOpen.apply(this, arguments);
    };
    XHR.send = function (body) {
      try {
        var url = this.__tecUrl || '';
        var method = (this.__tecMethod || '').toUpperCase();
        if (method === 'POST' && /\/cart(\/(update|add|change|clear)(\.js)?)?(\?|$)/i.test(url)) {
          var v = currentValue();
          if (v) {
            if (typeof body === 'string' && body.indexOf('Choose%20Your%20Location') === -1) {
              body = (body && body.length ? body + '&' : '') + 'attributes%5BChoose%20Your%20Location%5D=' + encodeURIComponent(v);
              log('XHR hook: appended to', url);
            } else if (body instanceof FormData && !body.has('attributes[Choose Your Location]')) {
              body.append('attributes[Choose Your Location]', v);
              log('XHR hook: appended FormData for', url);
            }
          }
        }
      } catch (e) {}
      return origSend.call(this, body);
    };
  } catch (e) {}

  window.addEventListener('pagehide', function () {
    var v = currentValue();
    if (v) {
      var body = 'attributes%5BChoose%20Your%20Location%5D=' + encodeURIComponent(v);
      try { navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/x-www-form-urlencoded;charset=UTF-8' })); } catch (e) {}
    }
  });

  log('cart location guard v6 ready');
})();
